import { constants, typographyStyles } from "@newsela/angelou";

const { heading4Obj, textMObj } = typographyStyles;
const grey = constants.colors.ui.neutral[500];

export const rootCss = {
  width: "100%",
  margin: "24px 0",
};

export const containerCss = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

export const headingCss = {
  ...heading4Obj,
  display: "flex",
  fontWeight: "bold",
  marginBottom: "16px",
};

export const headingTextCss = {
  marginRight: "16px",
};

export const iconCss = {
  width: 24,
  height: 24,
};

export const responseTextCss = {
  ...textMObj,
  margin: 0,
  textAlign: "left",
  color: grey,
};
